import { typography } from 'assets/styles'
import styled from 'styled-components'

// Keeps this field's own spacing from whatever comes after it (e.g. the
// "Add A Second Vehicle" button) self-contained here, rather than making
// every caller wrap it to get that spacing.
export const Root = styled.div`
    margin-bottom: 16px;
`

export const EquipmentNotice = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 16px;
`

export const EquipmentNoticeText = styled.p`
    ${typography.Copy14}
    margin: 0;
    color: ${(props) => props.theme.colors.monochrome.jetlineBlack};
`
